export const setAboutOpened = (opened) => {
    return {
        type: 'SET_ABOUT_OPENED',
        payload: opened
    }
}